import { LinkProps, UseNavigateResult } from "@tanstack/react-router";
import { type ClassValue, clsx } from "clsx";
import { format } from "date-fns";
import { twMerge } from "tailwind-merge";
import { v4 as uuid } from 'uuid';

export function camelToSnake(obj: unknown): unknown {
  if (obj === null || obj === undefined) {
    return obj;
  }

  if (Array.isArray(obj)) {
    return obj.map(camelToSnake);
  }

  if (obj instanceof Date) {
    return obj.toISOString()
  }

  if (typeof obj === "object") {
    return Object.fromEntries(
      Object.entries(obj).map(([key, value]) => [
        stringCamelToSnake(key),
        camelToSnake(value),
      ]),
    );
  }

  return obj;
}

function stringCamelToSnake(str: string) {
  return str.replace(/[A-Z]+/g, l => `_${l.toLowerCase()}`);
}

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function getUuid() {
  return uuid();
}

export function formatDate(date: Date) {
  return format(date, "eee dd MMMM, HH:mm");
}

export function formatInterval(seconds: number): string {
  const d = Math.floor(seconds / 86400);
  const h = Math.floor((seconds % 86400) / 3600);
  const m = Math.floor((seconds % 3600) / 60);
  const s = seconds % 60;

  let result = "";

  if (d > 0) result += `${d}d`;
  if (h > 0) result += `${h}h`;
  if (m > 0) result += `${m}m`;
  if (s > 0 || result === "") result += `${s}s`;

  return result;
}

export function scrollTo(navigate: UseNavigateResult<string>, linkProps: LinkProps, id?: string) {
  navigate(linkProps).then(() => {
    if (!id) return

    const element = document.getElementById(id)
    if (!element) return

    const offset = 100;
    const elementPosition = element.getBoundingClientRect().top;
    const offsetPosition = elementPosition + window.pageYOffset - offset;

    window.scrollTo({
      top: offsetPosition,
      behavior: "smooth",
    })
  })
}

export function capitalize(text: string) {
  if (text.length <= 1) return text.toUpperCase()

  return text[0].toUpperCase() + text.slice(1)
}
